export default __webpack_public_path__ + "static/media/pathfindingImage4.7fa38dd6.png";